module.exports = __webpack_public_path__ + "img/index-list-1.bd9c0cb2.png";